import { useEmailSniperLinkQueryQuery } from '@trello/graphql/generated';
import { useEffect, useState } from 'react';

const knownEmailProviders: { [key: string]: RegExp } = {
  gmail: /@(gmail|googlemail).com$/,
  yahoo: /@(yahoo|ymail).com$/,
  live: /@(hotmail|live).com$/,
  mac: /@(me|mac).com$/,
};

const emailProviderInboxes: { [key: string]: string } = {
  gmail: 'http://gmail.com',
  yahoo: 'http://mail.yahoo.com',
  live: 'http://live.com',
  mac: 'https://www.icloud.com/',
};

// Adds a search query to links to Gmail inboxes to filter by Trello
// and Atlassian emails to assist with the verification process
const addInboxSearchQuery = (inboxUrl: string) => {
  if (inboxUrl.startsWith('https://mail.google.com/')) {
    return `${inboxUrl}/#search/from:(@trello.com)+OR+from:(@atlassian.com)`;
  }

  return inboxUrl;
};

export const useEmailProvider = (email: string) => {
  const [inboxUrl, setInboxUrl] = useState('');

  useEffect(() => {
    // Loop through each regex and see if it matches.
    Object.entries(knownEmailProviders).forEach(([key, matcher]) =>
      matcher.test(email)
        ? setInboxUrl(addInboxSearchQuery(emailProviderInboxes[key]))
        : null,
    );
  }, [email]);

  // Send the request to the server for the email provider, the skip is
  // a little hack to skip if we have already matched a url above, hooks
  // cannot be conditional
  const { data } = useEmailSniperLinkQueryQuery({
    variables: { email },
    skip: inboxUrl !== '',
  });

  if (
    data &&
    data.emailProvider &&
    data.emailProvider.url &&
    addInboxSearchQuery(data.emailProvider.url) !== inboxUrl
  ) {
    setInboxUrl(addInboxSearchQuery(data.emailProvider.url));
  }

  return inboxUrl;
};
